import React from "react";

const Testing = () => {
  return (
    <div className="h-screen w-screen text-3xl font-semibold text-center flex items-center justify-center">
      This is Testing front page
    </div>
  );
};

export default Testing;
